<template>
  <div class="pay-agreement-page">
    <common-title titleName="购课须知" :bcColor="'#FEFEFF'" :zIndex="1000"/>
    <div v-html="agreement" class="content-center"></div>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import CommentTitle from '../../../components/header/CommonTitle';
import { payAgreement } from '../../../assets/js/agreement/payAgreement';

export default {
  name: 'payAgreement',
  component: {
    CommentTitle,
  },
  data() {
    return {
      agreement: payAgreement,
    };
  },
};
</script>

<style scoped lang="scss">
.pay-agreement-page{
  .content-center{
    padding: 120px 36px 100px;
    line-height: 48px;
  }
}
</style>
